module.exports = __webpack_public_path__ + "img/contract-original.b3526cad.webp";